import { Link, useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Trophy, Calendar, TrendingUp } from "lucide-react";
import { useChampionship } from "@/contexts/ChampionshipContext";

export const Hero = () => {
  const { championshipId } = useParams();
  const { selectedChampionship } = useChampionship();
  
  const championship = selectedChampionship || {
    name: "Serie D Maschile Gir. A",
    series: "Serie D",
    gender: "Maschile",
    group: "A"
  };
  
  return (
    <section className="relative overflow-hidden bg-primary py-20 sm:py-28">
      {/* Decorative Elements */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDM0djItaDJ2LTJoLTJ6bTAtNHYyaDJ2LTJoLTJ6bTAtNHYyaDJ2LTJoLTJ6bTAtNHYyaDJ2LTJoLTJ6bTAtNHYyaDJ2LTJoLTJ6bTItMnYyaDJ2LTJoLTJ6bS0yLTJ2Mmgydi0yaC0yem0wLTR2Mmgydi0yaC0yem0wLTR2Mmgydi0yaC0yeiIvPjwvZz48L2c+PC9zdmc+')] opacity-50"></div>
      
      <div className="container mx-auto px-4 relative">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 mb-6">
            <TrendingUp className="w-4 h-4 text-white" />
            <span className="text-sm font-medium text-white">Campionato in corso</span>
          </div>
          
          {/* Main Title */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            {championship.series} {championship.gender}
            <br />
            <span className="text-white/90">Girone {championship.group} - Puglia</span>
          </h1>
          
          <p className="text-lg sm:text-xl text-white/80 mb-10 max-w-2xl mx-auto">
            Segui tutte le partite, la classifica aggiornata e i risultati del campionato di pallavolo
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to={`/championship/${championshipId}/classifica`}>
              <Button size="lg" className="bg-white text-primary hover:bg-white/90 shadow-lg min-w-[180px]">
                <Trophy className="w-5 h-5 mr-2" />
                Classifica
              </Button>
            </Link>
            <Link to={`/championship/${championshipId}/calendario`}>
              <Button size="lg" variant="outline" className="bg-white/10 text-white border-white/30 hover:bg-white/20 backdrop-blur-sm min-w-[180px]">
                <Calendar className="w-5 h-5 mr-2" />
                Calendario
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
